import React from "react";
import { Outlet } from "react-router-dom";
import { useUserContext } from "../../../utils/contexts/UserProvider";
import { OMSpinner } from "../../atom/Spinner";
import { useProfileData } from "../../../utils/hooks/useProfileData";
import { Navbar } from "../../atom/Navbar";
import { cn } from "../../../utils/styles";

interface DefaultLayoutProps {
  hideNavbar?: boolean;
}

export const DefaultLayout: React.FC<DefaultLayoutProps> = ({ hideNavbar }) => {
  const { user } = useUserContext();
  useProfileData();

  if (!user) {
    return <OMSpinner />;
  }

  return (
    <main className={cn(!hideNavbar && "bg-gray-200 container:py-6 flex h-screen")}>
      <div
        className={cn(
          !hideNavbar && "flex max-w-[1600px] mx-auto border-x border-gray-200 bg-white flex-grow",
        )}>
        {!hideNavbar && <Navbar />}
        <Outlet />
      </div>
    </main>
  );
};
